import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue'
import TabHeader from './header/TabHeader.vue'

export type Tab = {
  title: string
  alias: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
  tabs: {
    type: Array as PropType<Array<Tab>>,
  },
  defaultAlias: String,
  hasMessage: Boolean,
  screen: String,
  loading: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TabHeader, {
      tabs: __props.tabs,
      "default-alias": __props.defaultAlias,
      "has-message": __props.hasMessage,
      screen: __props.screen,
      loading: __props.loading
    }, null, 8, ["tabs", "default-alias", "has-message", "screen", "loading"]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})